"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUsername = void 0;
var DEL_UUID_PATTERN = /^del_[a-z0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/;
var USERNAME_PATTERN = /^[a-z][a-z0-9_]+$/;
exports.isUsername = function (id) {
    return USERNAME_PATTERN.test(id) || DEL_UUID_PATTERN.test(id);
};
//# sourceMappingURL=username.js.map